const API = {
  // path: window.location.protocol + "//" + window.location.host + '/api/'
  // path: `https://wkcda-10a68.firebaseapp.com/api/`
  // path: `http://localhost:8081/api/`
  //path: (location) => `https://support.westkowloon.hk/api/`,
  path: (location) => `https://support.westkowloon.hk/api/`,
  //   path: (location) => `http://128.199.67.222/api/`
  // path: (location) => location.protocol+'//'+location.hostname+(location.port ? ':'+location.port+'/' : '/'),
  redirect_uri: `https://support.westkowloon.hk/donation/ciam/oauth_callback`,
  auth_url: `https://my.westkowloon.hk/services/oauth2/authorize`,
  token_url: "https://my.westkowloon.hk/services/oauth2/token",
  client_id:
    "3MVG9ZL0ppGP5UrC2xCi1BI8UChbFgi0AF.bkpAbaK1YMhWHCwjSLGaqExmUWbfy6dOnSiRSlK74.X.eJKPVM",
  client_secret: "",
  o_client_secret: "",
};

export default API;
